import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, EventEmitter, Inject, Input, NgZone, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import XmlBeautify from "src/app/script/xml-beautify.js";

export interface Variable{
    key:string;
    value:string;
    type:string;
}


@Component({
    selector: 'app-formula-tester',
    templateUrl: './formula-tester.component.html',
    styleUrls: ['./formula-tester.component.scss'],
    standalone: false
})
export class FormulaTesterComponent implements OnInit {
  messageLabel: BehaviorSubject<string> = new BehaviorSubject("Sem Resultado");

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  sub:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  sub4:Subscription;
  sub5:Subscription;
  canDuplicate: boolean = false;
  

  constructor( private _ngZone: NgZone,private snackBar:SnackbarService, private http:HTTPService,@Inject(MAT_DIALOG_DATA) public data:any, public dialogRef:MatDialogRef<any> ) { 
    
  }
  editing = true;
  listvariable:Variable[] = [];
  @Input()popup = false;
  @Input()small = false;
  @Input()ts = false;
  @Input()formula:string;
  @Input()params:Variable[] = [];
  @Output() formulaChange:EventEmitter<string> = new EventEmitter<string>();
  tipos:string[] = ['Texto','XML','JSON'];
  selectValue:string;
  select:string;
  keyControl = new UntypedFormControl('', Validators.required);
  valorControl = new UntypedFormControl('', Validators .required);
  tipoControl = new UntypedFormControl('', Validators .required);
  expressaoControl = new UntypedFormControl('',Validators.required);
  checked = false;
  selected:Variable = null;
  @Input() showTitle:boolean =true;
  salvarDisable = true;
  removeDisable = true;
  cancelDisable = true;
  novoDisable = false;
  click = false;
  changing = false;
  editObservable:BehaviorSubject<Boolean> = new BehaviorSubject(false);
  buttonList:ButtonList[] = [];

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this.sub = this._ngZone.onStable.pipe(take(1))
        .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  get tipo(){
    return this.tipoControl.value;
  }

  ngOnDestroy(){
      if ( this.sub!=null){this.sub.unsubscribe()}
      if ( this.sub2!=null){this.sub2.unsubscribe()}
      if ( this.sub3!=null){this.sub3.unsubscribe()}
      if ( this.sub4!=null){this.sub4.unsubscribe()}
      if ( this.sub5!=null){this.sub5.unsubscribe()}
  }

  okFunction(data){
      this.dialogRef.close(data);
  }

  close(){
    this.dialogRef.close();
  }

  ngOnInit(): void {
      this.disableControles();


      if ( ObjectUtil.isNotEmpty(this.data) ){
        this.popup = true;
        this.formula = this.data.formula;
        this.ts = this.data.ts;

        
      if (this.data.variables != null ){
        this.params = this.data.variables;
        this.params.forEach(d=>{
            this.listvariable.push(d);
        });
      }
        
      this.buttonList.push({
          color:"primary",
          description:"OK",
          action: (data)=>{
              this.okFunction(data);
          }
        })  

        this.buttonList.push({
          color:"warn",
          description:"Cancelar",
          action: (data)=>{
              this.close();
          }
        })  
      }
      
      this.sub2 = this.keyControl.valueChanges.subscribe(selectedValue => {
        if ( selectedValue != null ){
            if ( !this.click ){
              this.cancelDisable = false;
              this.salvarDisable = false;
            }
        }
      })
   
      this.sub3 = this.tipoControl.valueChanges.subscribe(selectedValue => {
        if ( selectedValue != null ){
          if ( !this.click ){
            this.cancelDisable = false;
            this.salvarDisable = false;
          }
        }
      })

      this.sub4 = this.valorControl.valueChanges.subscribe(selectedValue => {
        if ( selectedValue != null  ){
          if ( !this.click ){
            this.cancelDisable = false;
            this.salvarDisable = false;
          }
        }
      })
  }

  testar(){

      if ( this.expressaoControl.invalid ){
        this.snackBar.showError("Preecher expressão.");
        return;
      }
      
      
      let ob = {
          expressao: this.expressaoControl.value,
          novo: this.checked,
          values: this.listvariable
      }
      
      this.listvariable.forEach(d=>{
          if ( d.key == "@CODECOMPANY" ){
            ob['codecompany']=d.value;
            this.listvariable.push({key:"@CODECOMPANYRUNTIME",value:d.value,type:'T'});
          } 

          if ( d.key == "@CODEMKTP" ){
            ob['codemktp']=d.value;
            this.listvariable.push({key:"@CODEMKTPRUNTIME",value:d.value,type:'T'});
          } 
          if ( d.key == "@CODECONTRACT" ){
            ob['codecontract']=d.value;
            this.listvariable.push({key:"@CODECONTRACTRUNTIME",value:d.value,type:'T'});
          } 
      })
      
      this.sub5 = this.http.post(ob,"FormulaServices/test",true,true,false).subscribe(x=>{
          this.messageLabel.next(x['resultado']);
          
      });
  }


  ngModelChange(){
    this.cancelDisable = false;
    this.salvarDisable = false;
  }


  novo(){
    this.changing = false;
    this.enablControles();
    this.novoDisable = true;
    this.cancelDisable = false;
  }

  selectItem(event:MatSelectionListChange){

    this.click = true;
    this.selected = event.source.selectedOptions.selected[0].value;
    this.keyControl.setValue(this.selected.key);
    this.valorControl.setValue(this.selected.value);
    this.tipoControl.setValue(this.selected.type);
    this.enablControles(false);
    this.editing = true;
    this.novoDisable = true;
    this.removeDisable = false;
    this.canDuplicate = true;
    this.click = false;
    this.changing = true;
    
  }

  limparValor(formControl:UntypedFormControl){
    formControl.setValue('');
  }

  salvar(){
      if ( this.keyControl.invalid || this.valorControl.invalid || this.tipoControl.invalid ){
        this.keyControl.markAllAsTouched();
        this.valorControl.markAllAsTouched();
        this.tipoControl.markAllAsTouched();
        this.snackBar.showError("Preencher campos obrigatórios.");
        return;
      }else{
        if ( this.changing ){
            let index:number = this.listvariable.findIndex(x=> x.key == this.selected.key && x.type == this.selected.type && x.value == this.selected.value );
            this.listvariable[index] =  { key: this.keyControl.value, value: this.valorControl.value, type: this.select  }
        }else{
          if ( this.listvariable.findIndex(d=>d.key==this.keyControl.value)>-1){
            this.snackBar.showError("Já existe variável com esse nome.");
            return;
          }
          let variable:Variable = { key: this.keyControl.value, value: this.valorControl.value, type: this.select  }
          this.listvariable.push(variable);
        }
        
          this.changing = false;
          this.disableControles();
          this.salvarDisable = true;
          this.cancelDisable = true;
          this.novoDisable = false;
          this.canDuplicate = false;
      }
  }

  cancel(){
      this.novoDisable = false;
      this.removeDisable = true;
      this.salvarDisable = true;
      this.cancelDisable = true;
      this.canDuplicate = false;
      this.disableControles();
  }

  disableControles(){
      this.keyControl.reset();
      this.tipoControl.reset();
      this.valorControl.reset();
      this.keyControl.disable();
      this.tipoControl.disable();
      this.valorControl.disable();
  }

  enablControles(reset:boolean = true){
    if ( reset ){
      this.keyControl.reset();
      this.tipoControl.reset();
      this.valorControl.reset();
    }

    this.keyControl.enable();
    this.tipoControl.enable();
    this.valorControl.enable();
}

  remove(){
      let index:number = this.listvariable.findIndex(x=> x.key == this.selected.key && x.type == this.selected.type && x.value == this.selected.value );
      this.listvariable.splice(index,1);
      this.disableControles();
      this.novoDisable = false;
      this.salvarDisable = true;
      this.cancelDisable = true;
      this.canDuplicate = false;
      this.removeDisable = true;
  }

  changeFormula(event){
    this.formula = event;
    this.formulaChange.emit(this.formula);
  }

  duplicate(){
    if ( this.selected  != null ){
      this.keyControl.setValue(null);
      this.valorControl.setValue(this.selected.value);
      this.tipoControl.setValue(this.selected.type);
      this.enablControles(false);
      this.editing = true;
      this.novoDisable = true;
      this.removeDisable = false;
      this.click = false;
      this.changing = false;
    }
  }

  validate(){
      let valor:string = this.valorControl.value;
      let type:string = this.tipoControl.value;
      if ( type== "JSON"){
        try{
          let ob = JSON.parse(valor);
          let val:string = JSON.stringify(ob,null, "\t");
          this.valorControl.setValue(val);
        }catch(e){
          throw e;
        }
      }else{
          this.parseXml(valor).then(d=>{
            this.valorControl.setValue(d);
          });
      }
  }


  async parseXml(xmlString: string) {
    try{
      var beautifiedXmlText = new XmlBeautify().beautify(xmlString, 
      {
          indent: "  ",  //indent pattern like white spaces
          useSelfClosingElement: true //true:use self-closing element when empty element.
      });
      return beautifiedXmlText;
    }catch(Exception){
      throw Exception;
    }
    
  }

  export(){
    let data:string = this.valorControl.value;
    const file = new window.Blob([data], { type: 'text' });
    const downloadAncher = document.createElement("a");
    downloadAncher.style.display = "none";

    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = 'export_file.txt';
    downloadAncher.click();
  }

}
